{
  "errors": {
    "yourRoleDoesNotAllowThisAction": "บทบาทของคุณไม่อนุญาตให้{action}",
    "yourRoleDoesNotAllowYouToPerformThisAction": "บทบาทของคุณไม่อนุญาตให้ดำเนินการนี้",
    "mustHaveAtLeast8Characters": "ต้องมีอย่างน้อย 8 อักขระ",
    "mustContainUpperCaseAndLowerCase": "ต้องมีทั้งตัวพิมพ์ใหญ่และตัวพิมพ์เล็ก",
    "mustContainAtLeastOneLetter": "ต้องมีตัวอักษรอย่างน้อยหนึ่งตัว",
    "mustContainAtLeastOneSpecialCharacter": "ต้องมีอักขระพิเศษอย่างน้อยหนึ่งตัว",
    "mustContainAtLeastOneNumber": "ต้องมีตัวเลขอย่างน้อยหนึ่งตัว"
  },
  "descriptions": {
    "allPermissionsAndFullControlOverAllAccounts": "มีสิทธิ์ทั้งหมดและควบคุมบัญชีทั้งหมดได้อย่างสมบูรณ์",
    "godRoleWithLessControl": "บทบาท GOD ที่มีการควบคุมน้อยกว่า",
    "allPermissionsAndFullControlOverTheOrganizationAccount": "มีสิทธิ์ทั้งหมดและควบคุมบัญชีองค์กรได้อย่างสมบูรณ์",
    "createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "สร้าง/แก้ไข/ลบการนัดหมาย คลังสินค้า ประเภทสินค้า ท่าเทียบรถ และผู้ใช้ (ยกเว้นเจ้าของ)",
    "createEditCancelAppointments": "สร้าง/แก้ไข/ยกเลิกการนัดหมาย",
    "editAppointmentStatusTagsAndSubscribers": "แก้ไขสถานะการนัดหมาย แท็ก และผู้รับการแจ้งเตือน",
    "viewOnlyNoCreateOrEditActionsAllowed": "ดูได้อย่างเดียว ไม่อนุญาตให้สร้างหรือแก้ไข",
    "carrierAdministrator": "ผู้ดูแลระบบของผู้ขนส่ง",
    "carrierUser": "ผู้ใช้ของผู้ขนส่ง",
    "baseUserAccount": "บัญชีผู้ใช้พื้นฐาน",
    "warehouseDriverHasLimitedAccessToTheApplication": "คนขับของคลังสินค้า มีสิทธิ์เข้าถึงแอปพลิเคชันแบบจำกัด"
  }
}
